import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {Container} from "@pg-design/grid-module";
import {backgroundColor, calculateRemSize, flexAbsoluteCenter, flexDirection, maxWidth, onDesktop, pb, pt, pv, w75} from "@pg-design/helpers-css";
import {BrandOfferIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

export const CreditCalculatorMoreInfo = () => {
    const theme = useTheme();

    return (
        <div css={backgroundColor(theme.colors.gray[200])}>
            <Container css={flexAbsoluteCenter}>
                <div css={wrapper}>
                    <BrandOfferIcon size="6.4" wrapperSize="6.4" wrapperColor={theme.colors.primary} />

                    <Text as="p" variant="headline_3" align="center">
                        Weź kredyt hipoteczny z rynekpierwotny.pl
                    </Text>

                    <Text variant="body_copy_1" align="center">
                        Zbadaj swoją zdolność kredytową i sprawdź oferty banków. Teraz wraz z ekspertami serwisu rynekpierwotny.pl nie tylko znajdziesz swoje
                        wymarzone M, ale również zdobędziesz odpowiednie finansowanie. Skorzystaj z kalkulatora zdolności kredytowej oraz kalkulatora raty
                        kredytu!
                    </Text>
                </div>
            </Container>
        </div>
    );
};

const wrapper = (theme: Theme) => css`
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    gap: ${calculateRemSize(3)};
    ${pv(3)};

    ${onDesktop(pt(4), pb(5), w75)};

    @media (min-width: ${theme.breakpoints.lg}) {
        ${maxWidth("60%")};
    }
`;
import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {Container} from "@pg-design/grid-module";
import {backgroundColor, calculateRemSize, flexAbsoluteCenter, flexDirection, maxWidth, onDesktop, pb, pt, pv, w75} from "@pg-design/helpers-css";
import {BrandOfferIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

export const CreditCalculatorMoreInfo = () => {
    const theme = useTheme();

    return (
        <div css={backgroundColor(theme.colors.gray[200])}>
            <Container css={flexAbsoluteCenter}>
                <div css={wrapper}>
                    <BrandOfferIcon size="6.4" wrapperSize="6.4" wrapperColor={theme.colors.primary} />

                    <Text as="p" variant="headline_3" align="center">
                        Weź kredyt hipoteczny z rynekpierwotny.pl
                    </Text>

                    <Text variant="body_copy_1" align="center">
                        Zbadaj swoją zdolność kredytową i sprawdź oferty banków. Teraz wraz z ekspertami serwisu rynekpierwotny.pl nie tylko znajdziesz swoje
                        wymarzone M, ale również zdobędziesz odpowiednie finansowanie. Skorzystaj z kalkulatora zdolności kredytowej oraz kalkulatora raty
                        kredytu!
                    </Text>
                </div>
            </Container>
        </div>
    );
};

const wrapper = (theme: Theme) => css`
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    gap: ${calculateRemSize(3)};
    ${pv(3)};

    ${onDesktop(pt(4), pb(5), w75)};

    @media (min-width: ${theme.breakpoints.lg}) {
        ${maxWidth("60%")};
    }
`;
